import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { UserSessionService } from "src/app/services/usersession.service";
import swal from "sweetalert2";
import * as _ from "lodash";
import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";
import { FormGroup } from "@angular/forms";
import { AuthenticationService } from "src/app/services/authentication.service";
import { environment } from "src/environments/environment";
import * as jwtDecode from 'jwt-decode';
import { DOCUMENT } from "@angular/common";

@Component({
  selector: 'app-bc-navbar',
  templateUrl: './bc-navbar.component.html',
  styleUrls: ['./bc-navbar.component.scss']
})
export class BCNavbarComponent implements OnInit {

  username: any;
  userId: number;
  emailId: any;
  auth: any;
  webversion: any;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public translate: TranslateService,
    private userSessionService: UserSessionService,
    private router: Router,
    public dialog: MatDialog,
    private authService: AuthenticationService,
  ) {
    // this.emailId = userSessionService.getEmail();
    this.username = userSessionService.cardholderName();
  }

  ngOnInit(): void {
  }



}
